import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { memo } from 'react';
import { DragLayer } from 'react-dnd';
import { DragLayerRef, dragLayerCollector } from 'utils/dnd/dragLayerCollector';
import { TopologyLayoutSettingsProtocolsGroup } from './TopologyLayoutSettingsProtocolsGroup';
import type { DragGroupItem } from './useGroupDragAndDrop';

interface DragLayerProps {
  itemType: string | symbol | null;
  item: DragGroupItem | null;
}

const dragLayerRef = new DragLayerRef();

const BareTopologyLayoutSettingsProtocolsGroupDragLayer = DragLayer(
  dragLayerCollector(dragLayerRef),
)((props: DragLayerProps) => {
  const ctxProps = useGraphContextSelectors({
    draggedGroupId: prop('layoutSettings', 'draggedGroupId'),
  });

  const groupIsDragged =
    ctxProps.draggedGroupId !== null &&
    ctxProps.draggedGroupId === props.item?.groupId;
  if (!groupIsDragged) {
    return null;
  }

  return (
    <div className='graph-draggable-item__preview'>
      <div
        ref={(ref) => {
          dragLayerRef.setElement(ref);
        }}
        className='graph-draggable-item__box-shadow flex flex-1 flex-col'
      >
        {props.itemType === 'group' && (
          // Drag preview group
          <TopologyLayoutSettingsProtocolsGroup
            {...props}
            groupGrouped={false}
            groupVisible
            otherProtocols={false}
            draggedGroupId={null}
            groupId={props.item!.groupId}
            groupIndex={props.item!.groupIndex}
            groupName={props.item!.groupName}
            protocols={props.item!.protocols}
            style={props.item!.style}
          />
        )}
      </div>
    </div>
  );
});

export const TopologyLayoutSettingsProtocolsGroupDragLayer = memo(
  BareTopologyLayoutSettingsProtocolsGroupDragLayer,
);
